/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import { setScreenTaskController, showGuideScreen } from '../../screens/screens.reducers';
import {
    highlightSubmenuScreens,
    onKeydownSettingsOperations,
    onKeyDownSettingsSubmenuOperations,
    onKeyOkAccountSettingsOperations,
    onKeyOkUserPreferenceSettings,
    onKeyUpSettingsOperations,
    onKeyUpSettingsSubmenuOperations,
    onMouseClickSettingsOperations,
    onMouseOutSettingsOperations,
    onMouseOverSettingsOperations,
    setSubmenuTasksController,
} from '../settings.reducers';
import {
    setEnteredNumberAction,
    setFocusedItemIndexAction,
    setIsMenuFocusedAction,
    setIsSubmenuFocusedAction,
    setSubmenuVerticalPositionAction,
} from '../settings.actions';
import {
    onKeyOkAccountsOverlay,
    signOut,
    onMouseClickAccountsOverlay,
} from '../accountsoverlays/accountsoverlays.reducers';
import {
    hideMenuLanguage,
    onKeyBackMenuLanguageSettings,
    onKeyDownMenuLanguageOperations,
    onKeyOkMenuLanguageOperations,
    onKeyUpMenuLangaugeOperations,
    onMouseClickMenuLanguageOperations,
} from '../menulanguage/menulanguage.reducers';
import { SettingsState } from '../settingsstate';
import { DeviceModel } from '../../../core/device/DeviceModel';
import { SettingsMenuTypes } from '../../../views/SettingsScreen/SettingsMenuTypes';
import {
    hideOverlayDialog,
    onKeyDownOverlayDialaog,
    onKeyUpOverlayDialog,
    onMouseOutOverlayDialogOperations,
    onMouseOverOverlayDialogOperations,
} from '../../overlaydialog/overlaydialog.reducers';
import {
    settingsVideoWindowHide,
    onKeyBackSettingsVideoWindowOperations,
    onKeyOkSettingsVideoWindowOperations,
    onMouseOutSettingsVideoWindowOperations,
    onMouseOverSettingsVideoWindowOperations,
    onKeyRightSettingsVideoWindowOperations,
    onMouseClickInteractiveLayerOperations,
    onKeyLeftSettingsVideoWindowOperations,
} from '../settingsvideowindow/settingsvideowindow.reducers';

export const onKeyBackSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.SETTINGS_ACCOUNT_TASKS:
        case ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_USER_PREFERENCE_TASKS:
            dispatch(showGuideScreen());
            break;

        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(hideOverlayDialog());
            break;

        case ScreenTaskControllerTypes.SETTINGS_MENU_LANGUAGE_TASKS:
            dispatch(onKeyBackMenuLanguageSettings());
            break;

        case ScreenTaskControllerTypes.SETTINGS_VIDEO_WINDOW_TASKS:
            dispatch(onKeyBackSettingsVideoWindowOperations());
            break;

        default:
    }
};

export const onKeyDownSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS:
            dispatch(onKeydownSettingsOperations());
            break;
        case ScreenTaskControllerTypes.SETTINGS_MENU_LANGUAGE_TASKS:
            dispatch(onKeyDownMenuLanguageOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_ACCOUNT_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_USER_PREFERENCE_TASKS:
            dispatch(onKeyDownSettingsSubmenuOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
            dispatch(onKeyDownOverlayDialaog());
            break;

        default:
    }
};

export const onKeyUpSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS:
            dispatch(onKeyUpSettingsOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_MENU_LANGUAGE_TASKS:
            dispatch(onKeyUpMenuLangaugeOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_USER_PREFERENCE_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_ACCOUNT_TASKS:
            dispatch(onKeyUpSettingsSubmenuOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
            dispatch(onKeyUpOverlayDialog());
            break;

        default:
    }
};

export const onKeyRightSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS:
            dispatch(setSubmenuTasksController());
            dispatch(highlightSubmenuScreens());
            break;

        case ScreenTaskControllerTypes.SETTINGS_VIDEO_WINDOW_TASKS:
            dispatch(onKeyRightSettingsVideoWindowOperations());
            break;

        default:
    }
};

export const onKeyLeftSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    const { menuVerticalPosition } = getState().settings;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.SETTINGS_USER_PREFERENCE_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_ACCOUNT_TASKS:
            dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS));
            dispatch(setFocusedItemIndexAction(menuVerticalPosition));
            dispatch(setIsMenuFocusedAction(true));
            dispatch(setIsSubmenuFocusedAction(false));
            dispatch(setSubmenuVerticalPositionAction());
            break;

        case ScreenTaskControllerTypes.SETTINGS_VIDEO_WINDOW_TASKS:
            dispatch(onKeyLeftSettingsVideoWindowOperations());
            break;

        default:
    }
};

export const onKeyOkSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS:
            dispatch(setSubmenuTasksController());
            dispatch(highlightSubmenuScreens());
            break;

        case ScreenTaskControllerTypes.SETTINGS_ACCOUNT_TASKS: {
            dispatch(onKeyOkAccountSettingsOperations());
            break;
        }

        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(onKeyOkAccountsOverlay());
            break;

        case ScreenTaskControllerTypes.SETTINGS_USER_PREFERENCE_TASKS:
            dispatch(onKeyOkUserPreferenceSettings());
            break;

        case ScreenTaskControllerTypes.SETTINGS_MENU_LANGUAGE_TASKS:
            dispatch(onKeyOkMenuLanguageOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_VIDEO_WINDOW_TASKS:
            dispatch(onKeyOkSettingsVideoWindowOperations());
            break;

        default:
    }
};

export const onKeyGuideSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(hideOverlayDialog());
            break;

        case ScreenTaskControllerTypes.SETTINGS_MENU_LANGUAGE_TASKS:
            dispatch(hideMenuLanguage());
            break;

        case ScreenTaskControllerTypes.SETTINGS_VIDEO_WINDOW_TASKS:
            dispatch(settingsVideoWindowHide());
            break;

        default:
    }
    dispatch(showGuideScreen());
};

// __START_DEBUG_CODE_CLEANUP__
export const onKeyDigitSettings = () => async (dispatch: Function, getState: Function) => {
    const { menuVerticalPosition } = getState().settings;
    if (menuVerticalPosition === SettingsState.HELP) {
        const { key } = getState().inputFactory;
        const { enteredNumber } = getState().settings;
        const newNumber = `${enteredNumber}${key}`;
        if (DeviceModel.isValidPasscode(newNumber)) {
            await dispatch(signOut());
            DeviceModel.enableBackdoor(newNumber);
        }
        dispatch(setEnteredNumberAction(newNumber));
    }
};
// __END_DEBUG_CODE_CLEANUP__

export const onMouseOverSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    const { value } = getState().inputFactory;
    const menuItems = value.split('-');
    const focusItemIndex = Number(menuItems[0]);
    const listType = menuItems[1];
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_ACCOUNT_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_USER_PREFERENCE_TASKS:
            dispatch(onMouseOverSettingsOperations(focusItemIndex, listType));
            break;

        case ScreenTaskControllerTypes.SETTINGS_MENU_LANGUAGE_TASKS:
            dispatch(setFocusedItemIndexAction(focusItemIndex));
            dispatch(setIsMenuFocusedAction(true));
            break;

        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(onMouseOverOverlayDialogOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_VIDEO_WINDOW_TASKS:
            dispatch(onMouseOverSettingsVideoWindowOperations());
            break;

        default:
    }
};

export const onMouseOutSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_ACCOUNT_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_USER_PREFERENCE_TASKS:
            dispatch(onMouseOutSettingsOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_MENU_LANGUAGE_TASKS:
            dispatch(setIsMenuFocusedAction(false));
            break;

        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(onMouseOutOverlayDialogOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_VIDEO_WINDOW_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_INTERACTIVE_LAYER_TASKS:
            dispatch(onMouseOutSettingsVideoWindowOperations());
            break;

        default:
    }
};

export const onMouseClickSettings = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    const { value } = getState().inputFactory;
    const menuItems = value.split('-');
    const focusItemIndex = Number(menuItems[0]);
    const listType = menuItems[1];
    const isOutOfMenu = !value.includes('-');
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS:
            if (listType === SettingsMenuTypes.MENU) {
                dispatch(onMouseClickSettingsOperations(focusItemIndex));
            }
            break;

        case ScreenTaskControllerTypes.SETTINGS_ACCOUNT_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_USER_PREFERENCE_TASKS:
            if (listType === SettingsMenuTypes.MENU) {
                dispatch(onMouseClickSettingsOperations(focusItemIndex));
                dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_SETTING_TASKS));
            } else {
                dispatch(onKeyOkSettings());
            }
            break;

        case ScreenTaskControllerTypes.SETTINGS_MENU_LANGUAGE_TASKS:
            dispatch(onMouseClickMenuLanguageOperations(focusItemIndex, isOutOfMenu));
            break;

        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(onMouseClickAccountsOverlay());
            break;

        case ScreenTaskControllerTypes.SETTINGS_VIDEO_WINDOW_TASKS:
            dispatch(onKeyOkSettingsVideoWindowOperations());
            break;

        case ScreenTaskControllerTypes.SETTINGS_INTERACTIVE_LAYER_TASKS:
            dispatch(onMouseClickInteractiveLayerOperations());
            break;

        default:
    }
};
